import { eSinhVienDangKyThucTapActionsObj } from "../../action-types/xet-thuc-tap/ISinhVienDangKyThucTapActions";
import { generateActions } from "../generateActions";

export const sinhVienDangKyThucTapActions = {
    ...generateActions(eSinhVienDangKyThucTapActionsObj, "SINH_VIEN_DANG_KY_THUC_TAP"),
}